var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_262_13113",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
          },
        },
        [_c("rect", { attrs: { width: "20", height: "20", fill: "#D9D9D9" } })]
      ),
      _vm._v(" "),
      _c("g", { attrs: { mask: "url(#mask0_262_13113)" } }, [
        _c("path", {
          attrs: {
            d: "M10 17C8.16667 17 6.59375 16.3924 5.28125 15.1771C3.96875 13.9618 3.22222 12.4653 3.04167 10.6875C3.01389 10.4931 3.07292 10.3299 3.21875 10.1979C3.36458 10.066 3.54125 10 3.74875 10C3.94403 10 4.11806 10.0556 4.27083 10.1667C4.42361 10.2778 4.51389 10.4306 4.54167 10.625C4.69444 12 5.28819 13.1562 6.32292 14.0938C7.35764 15.0312 8.58333 15.5 10 15.5C11.5139 15.5 12.809 14.9618 13.8854 13.8854C14.9618 12.809 15.5 11.5139 15.5 10C15.5 8.48611 14.9618 7.19097 13.8854 6.11458C12.809 5.03819 11.5139 4.5 10 4.5C9.13889 4.5 8.3434 4.67778 7.61354 5.03333C6.88382 5.38889 6.26958 5.87778 5.77083 6.5H7.25C7.4625 6.5 7.64062 6.57146 7.78438 6.71437C7.92813 6.85729 8 7.03437 8 7.24562C8 7.45687 7.92813 7.63542 7.78438 7.78125C7.64062 7.92708 7.4625 8 7.25 8H3.75C3.5375 8 3.35938 7.92813 3.21563 7.78438C3.07188 7.64063 3 7.4625 3 7.25V3.75C3 3.5375 3.07146 3.35937 3.21437 3.21562C3.35729 3.07187 3.53437 3 3.74562 3C3.95687 3 4.13542 3.07187 4.28125 3.21562C4.42708 3.35937 4.5 3.5375 4.5 3.75V5.70833C5.13889 4.875 5.93403 4.21528 6.88542 3.72917C7.83681 3.24306 8.875 3 10 3C10.9722 3 11.8828 3.18472 12.7319 3.55417C13.581 3.92361 14.3199 4.42271 14.9485 5.05146C15.5773 5.68007 16.0764 6.41896 16.4458 7.26813C16.8153 8.11715 17 9.02778 17 10C17 10.9722 16.8153 11.8828 16.4458 12.7319C16.0764 13.581 15.5773 14.3199 14.9485 14.9485C14.3199 15.5773 13.581 16.0764 12.7319 16.4458C11.8828 16.8153 10.9722 17 10 17ZM10.75 9.375L12.625 11.25C12.7778 11.4028 12.8507 11.5764 12.8438 11.7708C12.8368 11.9653 12.7569 12.1389 12.6042 12.2917C12.4514 12.4444 12.2743 12.5208 12.0729 12.5208C11.8715 12.5208 11.6944 12.4444 11.5417 12.2917L9.48521 10.2352C9.41174 10.1617 9.35417 10.0785 9.3125 9.98563C9.27083 9.89271 9.25 9.79674 9.25 9.69771V6.74333C9.25 6.53264 9.32292 6.35611 9.46875 6.21375C9.61458 6.07125 9.79167 6 10 6C10.2083 6 10.3854 6.07187 10.5312 6.21562C10.6771 6.35937 10.75 6.5375 10.75 6.75V9.375Z",
            fill: "#8796AF",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }